import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useModel } from "hooks/useModel";
import styles from "./ChatArea.module.scss";
import ChatAreaDefault from "./ChatAreaDefault";
import { fetchMessages } from "../../store/MessageActions";
import { useAxios } from "myAxios";
import ChatAreaMessage from "./ChatAreaMessage";

const ChatArea = () => {
  const { chatlist, setChatlist, selectedKey } = useModel("aichat");
  const [loading, setLoading] = useState(false);

  const axios = useAxios();
  useEffect(() => {
    const currentChat = chatlist.find((item) => item.id === selectedKey);
    if (!currentChat?.content && !!selectedKey) {
      setLoading(true);
      fetchMessages(axios, selectedKey)
        .then((res) => {
          setChatlist((chatlist) =>
            chatlist.map((item) => {
              if (item.id === selectedKey) {
                return { ...item, content: res as any };
              }
              return item;
            })
          );
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [selectedKey]);

  return (
    <Box className={styles.chatArea}>
      {loading && <div className={styles.spinMask} />}
      {chatlist.find((item) => item.id === selectedKey)?.content?.length ? (
        <ChatAreaMessage />
      ) : (
        <ChatAreaDefault />
      )}
    </Box>
  );
};

export default ChatArea;
